const testimonials = [
  {
    name: 'Jean-Pierre B.',
    initials: 'JP',
    role: 'Particulier — Nice Est',
    rating: 5,
    text: 'Polar Clim a installé ma climatisation en une demi-journée, soigneusement, sans laisser de trace. Le technicien était ponctuel, propre et très professionnel. Je recommande sans hésiter.',
    avatarColor: '#003580',
  },
  {
    name: 'Nathalie V.',
    initials: 'NV',
    role: 'Commerçante — Vieux-Nice',
    rating: 5,
    text: 'Dépannage express en pleine canicule, arrivée en moins de 2h ! Très bonne communication, tarif honnête. Mon commerce a pu rester ouvert grâce à leur réactivité. Merci à toute l\'équipe.',
    avatarColor: '#1a8abf',
  },
  {
    name: 'Rémi & Clara T.',
    initials: 'RC',
    role: 'Propriétaires — Cagnes-sur-Mer',
    rating: 5,
    text: 'Contrat d\'entretien annuel, toujours au top. Ils font un bilan complet, nettoient les filtres, vérifient les pressions. On a une vraie tranquillité d\'esprit toute l\'année.',
    avatarColor: '#7c3aed',
  },
];

const StarRating = ({ count }: { count: number }) => (
  <div className="flex gap-1">
    {Array.from({ length: 5 }).map((_, i) => (
      <i
        key={i}
        className={i < count ? 'ri-star-fill' : 'ri-star-line'}
        style={{ color: '#F59E0B', fontSize: 18 }}
      />
    ))}
  </div>
);

const TestimonialsSection = () => (
  <section id="temoignages" className="w-full py-24" style={{ background: '#f0f8fc' }}>
    <div className="max-w-7xl mx-auto px-6">

      {/* Header */}
      <div className="text-center mb-14">
        <span
          className="inline-block text-white text-xs font-bold px-5 py-2 rounded-full mb-4 tracking-widest uppercase"
          style={{ background: 'linear-gradient(90deg, #003580 0%, #4ab8d0 100%)' }}
        >
          Témoignages
        </span>
        <h2 className="text-4xl lg:text-5xl font-black leading-tight mb-4" style={{ color: '#002060' }}>
          Ce que disent<br />nos clients
        </h2>
        <p className="text-[#4a6272] text-lg max-w-xl mx-auto">
          Des retours sincères de clients dans la région de Nice — notre réputation se construit projet après projet.
        </p>
      </div>

      {/* Cards */}
      <div className="flex flex-wrap justify-center gap-6">
        {testimonials.map((t) => (
          <div
            key={t.name}
            className="bg-white rounded-2xl p-8 border border-[#e0eef8] flex flex-col gap-5"
            style={{ width: 360 }}
          >
            <StarRating count={t.rating} />
            <p className="text-[#4a6272] text-base leading-relaxed italic flex-1">
              &ldquo;{t.text}&rdquo;
            </p>
            <div className="flex items-center gap-4 pt-4 border-t border-[#e8f4fc]">
              <div
                className="w-12 h-12 flex items-center justify-center rounded-full flex-shrink-0 text-white font-black text-sm"
                style={{ background: t.avatarColor }}
              >
                {t.initials}
              </div>
              <div>
                <p className="font-bold text-sm" style={{ color: '#002060' }}>{t.name}</p>
                <p className="text-xs text-[#8aa0b0]">{t.role}</p>
              </div>
              <span className="ml-auto flex items-center gap-1 text-[10px] font-bold text-green-600 bg-green-50 px-2 py-1 rounded-full whitespace-nowrap">
                <i className="ri-checkbox-circle-fill" style={{ fontSize: 11 }} />
                Vérifié
              </span>
            </div>
          </div>
        ))}
      </div>

    </div>
  </section>
);

export default TestimonialsSection;
